import React, { useState, useEffect, useRef, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
  SecondaryButton,
  Title,
  TextField,
  TextAreaInput,
  ActionButton,
  ErrorText,
  IconButton,
} from "../../atoms";
import { ErrorWrapper } from "../../molecules";
import { AnalyticsService } from "../../../utils/Analytics";
import Select from "react-select";
import ImageUploading from "react-images-uploading";
import validator from "../../../utils/validations";
import { ADDNEWPRODUCT, GETCATEGORYFIELDS } from "../../../api/apiConfig";
import { apiGet, apiPost, Messages } from "../../../utils";
import { getListFiles, toVideoData } from "../../../utils/fileUtils";
import VariantItem from "../VariantItem/VariantItem";
import VariantEdit from "../VariantEdit/VariantEdit";
import TraitsInput from "../TraitEdit/TraitsInput";
import { variantsByCategory, optionsByCategory, bespokeBatOptions } from "./variantData";
import {
  getProductModels,
  getProductWeights,
  getProductGrades,
  getProductDescription,
} from "../../../api/api";
import { useQuery } from "react-query";
import { Container } from "../../DragDropCard/DragDropCard";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImageResizer from "../ImageResizer/ImageResizer";
import CircularProgress from '@mui/material/CircularProgress';
import toast from "react-hot-toast";
import { ActionButton2 } from "../../atoms/ActionButton2/ActionButton2";
import { useMediaQuery } from "react-responsive";

const VideoLayout = (props) => {
  const { className, overlayClass, src, onClick, idx } = props;
  return (
    <div className={className}>
      <div className={overlayClass} />
      <video controls className="formImg">
        <source src={src}></source>
      </video>
      {/* <img src={src} className="formImg" /> */}
      <IconButton onClick={() => onClick(idx)} className="imageRemoveCls" />
    </div>
  );
};

const hasFormErrors = (errors) => {
  return Object.keys(errors).length > 0;
};

const batCategories = ["Bespoke Cricket Bats", "Workshop Cricket Bats"];
const bespokeCategoryName = "Bespoke Cricket Bats";

export const AddProductForm = ({
  setShowProduct,
  onCancelClick,
  getProducts,
  productCategories,
  setShowList,
}) => {
  const videoInputRef = useRef();

  const [state, setState] = useState({
    description: "",
    productName: "",
    productPrice: "",
    quantity: "0",
    isLoading: false,
    images: [],
    videos: [],
    selectedCategory: {},
    customModel: null,
    customModel: null,
    selectedModel: null,
    selectedGrade: null,
    selectedWeight: null,
    fields: [],
  });
 
  const {
    description,
    productName,
    productPrice,
    quantity,
    isLoading,
    images,
    videos,    
    selectedCategory,
    fields,
    selectedModel,
    customModel,
    customGrade,
    selectedGrade,
    selectedWeight,
  } = state;

  const prodCategories =
    productCategories &&
    productCategories.map((m) => ({
      value: m.id,
      label: m.name,
    }));

  const currentCategory = selectedCategory?.label
    ? selectedCategory
    : prodCategories[0];

  const {
    isLoading: isProductModelsLoading,
    data: { data: productModels } = { data: [] },
  } = useQuery(
    ["models", selectedCategory?.value],
    () => getProductModels(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const {
    isLoading: isProductWeightsLoading,
    data: { data: productWeights } = { data: [] },
  } = useQuery(
    ["weights", selectedCategory?.value],
    () => getProductWeights(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const {
    isLoading: isProductGradesLoading,
    data: { data: productGrades } = { data: [] },
  } = useQuery(
    ["grades", selectedCategory?.value],
    () => getProductGrades(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const {
    isLoading: isProductDescriptionLoading,
    data: { data: productDescription } = { data: null },
  } = useQuery(
    ["descriptions", selectedCategory?.value, selectedModel?.value],
    () => getProductDescription(currentCategory.value, selectedModel?.value),
    {
      enabled: currentCategory != null && selectedModel != null,
    }
  );

  const [nameError, setNameError] = useState("");
  const [descError, setDescError] = useState("");
  const [priceError, setPriceError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [imageError, setImageError] = useState({});
  const [invalidData, setInvalidData] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isTryBeforeYouBuy, setIsTryBeforeYouBuy] = useState(false);
  const [weightError, setWeightError] = useState("");
  const [selectedVariant, setSelectVariant] = useState(null);
  const [variants, setVariants] = useState([]);
  const [videoErr, setVideoErr] = useState();
  const [tbyb, settbyb] = useState({ value: false, label: "No" });
  const [exclusiveTag, setExclusiveTag] = useState({ value: false, label: "No" });
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [traitsEdit, setTraitsEdit] = useState(false);
  const [traits, setTraits] = useState(null);
  const hasVariants = !!variants.length;
  const schema = yup
    .object({
      variants: yup
        .array()
        .of(
          yup.object({
            // inventoryQuantity: yup
            //   .string()
            //   .required("Quantity is a required field"),
            // price: yup.number().required("Price is a required field"),
          })
        )
        .length(variants.length),
    })
    .required();

  const methods = useForm({
    values: {
      variants: variants.map(() => {
        return {};
      }),
    },
    resolver: yupResolver(schema),
    resetOptions: {
      keepDirtyValues: true,
    },
  });
  const {
    formState: { errors: formErrors },
    getValues,
    handleSubmit,
    setValue,
  } = methods;

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })

  const updateState = (data) =>
    setState((prevState) => ({ ...prevState, ...data }));

  useEffect(() => {
    const category = selectedCategory?.label
      ? selectedCategory
      : prodCategories[0];

    setVariants(variantsByCategory[category.label] ?? []);
  }, [selectedCategory]);

  useEffect(() => {
    if (productCategories && productCategories.length !== 0) {
      const categoryId = productCategories[0].id;
      getFieldHeadingsAndValues(categoryId);
    }
  }, []);

  useEffect(() => {
    if (productDescription) {
      updateState({ description: productDescription.title });
    }
  }, [productDescription]);

  useEffect(() => {
    let userName = "";
    if(localStorage.getItem("roleId") == 1)
    {
      userName = localStorage.getItem("xSwitch");
    }
    else
    {
        userName = localStorage.getItem("userName");
    }
    let productName = userName;

    if (selectedModel) {
      
      if(selectedCategory?.label == 'Helmets' && selectedModel.label != null )
        {
          var prodName = 'Helmet'
          productName = `${productName} ${selectedModel.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Bags' && selectedModel.label != null )
        {
          var prodName = 'Bag'
          productName = `${productName} ${selectedModel.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Shoes' && selectedModel.label != null )
        {
          var prodName = 'Shoes'
          productName = `${productName} ${selectedModel.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Wicket Keeping Gloves' && selectedModel.label != null )
        {
          var prodName = 'Wicket Keeping Gloves'
          productName = `${productName} ${selectedModel.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Wicket Keeping Pads' && selectedModel.label != null )
        {
          var prodName = 'Wicket Keeping Pads'
          productName = `${productName} ${selectedModel.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Accessories' && selectedModel.label != null )
        {
         
          productName = `${productName} ${selectedModel.label}`;
        }
        else if(selectedCategory?.label == 'Clothing' && selectedModel.label != null )
        {

          var prodName = 'Clothing'
          productName = `${productName} ${selectedModel.label}`;
        }
          
      
    }

    if (selectedGrade) {
     
        if(selectedCategory?.label == 'Bespoke Cricket Bats' && selectedModel.label != null && selectedGrade.label != null)
        {
          var prodName = 'Cricket Bat'
          productName = `${productName} ${selectedModel.label} ${selectedGrade.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Workshop Cricket Bats' && selectedModel.label != null && selectedGrade.label != null)
        {
          var prodName = 'Cricket Bat'
          productName = `${productName} ${selectedModel.label} ${selectedGrade.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Batting Gloves' && selectedModel.label != null && selectedGrade.label != null)
        {
          var prodName = 'Batting Gloves'
          productName = `${productName} ${selectedModel.label} ${selectedGrade.label} ${prodName}`;
        }
        else if(selectedCategory?.label == 'Batting Pads' && selectedModel.label != null && selectedGrade.label != null)
        {
          var prodName = 'Batting Pads'
          productName = `${productName} ${selectedModel.label} ${selectedGrade.label} ${prodName}`;
        }
             
    }
    if (selectedCategory?.label) {
     // productName = `${productName} ${selectedCategory?.label} `;
    }
    updateState({ productName: productName });
  }, [selectedCategory, selectedGrade, selectedModel]);

  const changeTextValues = (e,hasVariant=null) => {
    updateState({ [e.target.name]: e.target.value });
    if(hasVariant==1){
     const updatedVariants=  variants.map((v) => {
          return { ...v, price:e.target.value };
      });
      setVariants(updatedVariants);
    }
    if(hasVariant==2){
      const updatedVariants= variants.map((v) => {
          return { ...v, inventoryQuantity:e.target.value };
      });
      setVariants(updatedVariants);
    }
  };

  const setSelectedProductModel = (option) => {
    updateState({ selectedModel: option });
  };

  const handleSelectedProductModelInputChange = (inputValue) =>{
    if(inputValue === null || inputValue === "" || inputValue === undefined) return;
    
    updateState({ selectedModel: {value:0, label:inputValue}, customModel: inputValue });
    
  };

  const setSelectedProductGrade = (option) => {
    console.log(option);
    updateState({ selectedGrade: option });
  };
  const handleSelectedProductGradeInputChange = (inputValue)=>{
    if(inputValue === null || inputValue === "" || inputValue === undefined) return;
    
    updateState({ selectedGrade: {value:0, label:inputValue}, customGrade: inputValue });
    
  };

  const setSelectedWeight = (option) => {
    updateState({ selectedWeight: option });
  };

  const setSelectedCategory = (option) => {
    updateState({ selectedCategory: option, selectedModel: null, selectedGrade: null });
    const { value } = option;
    if (value !== 0) {
      getFieldHeadingsAndValues(value);
    }
  };

  const setOption = (heading, option) => {
    setSelectedOptions((data) => [
      ...data.filter((m) => m.heading !== heading),
      { heading: heading, selectedValue: option.label },
    ]);
  };

  const getFieldHeadingsAndValues = async (categoryId) => {
    const res = await apiGet(`${GETCATEGORYFIELDS}/${categoryId}`);
    if (res) {
      const { data } = res;
      const options = data.map((m) => {
        return {
          id: m.id,
          heading: m.heading,
          fieldValues: m.fieldValues.map((e) => ({
            value: e.id,
            label: e.value,
          })),
        };
      });
      updateState({ fields: options });
    }
  };

  const onImageChange = async (imageList, addUpdateIndex) => {
    setIsImageLoading(true);
    setImageError({});
    let images = [];
    
    for (let index = 0; index < imageList.length; index++){
      const img = imageList[index];
      if (!img.image) {
        let newImage = new Image();
        newImage.src = URL.createObjectURL(img.file);
        images = await loadImage(imageList, img, newImage, images);
      } else {
        images.push(img);
      }
    };
    updateState({ images: images });
    setIsImageLoading(false);
  };
  const loadImage = async (imageList, img, newImage, imageArray) => {
    return new Promise((resolve) => {
      newImage.onload = async () => {
        let megaPixels = (newImage.width * newImage.height) / 1000000;
  
        if (imageList.length > 0) {
          if (megaPixels > 19) {
            let resizedImage = new Image();
            
            console.log("Image is above 20MP...");
            let fileToResize = img.file;
            let maxWidth = 3000;
            let maxHeight = 4000;
  
            const imageResizer = ImageResizer(fileToResize, maxWidth, maxHeight);
            try {
              const resizedImageBlob = await imageResizer.resizeImage();
              resizedImage.src = URL.createObjectURL(resizedImageBlob);
              newImage.width = maxHeight;
              newImage.height = maxHeight;
                
              const resizedImageUrl = await LoadResizedImage(resizedImageBlob, resizedImage);
              
  
              imageArray.push({
                image: img,
                src: resizedImage.src,
                imageName: img.file.name,
                imageType: img.file.type,
                imageb64: resizedImageUrl.split(";")[1].split(",")[1],
              });
            } catch (error) {
              console.error('Error resizing image:', error);
            }
          } else {
            imageArray.push({             
              src: newImage.src,
              imageName: img.file.name,
              imageType: img.file.type,
              imageb64: img.data_url.split(";")[1].split(",")[1],
              image : img
            });
          }
        }
  
        resolve(imageArray);
      };
    });
  };
  const LoadResizedImage = async (resizedImageBlob, resizedImage) =>{
    return new Promise((resolve) => {
      resizedImage.onload = async () => {
        console.log("resized width ", resizedImage.width, " height ", resizedImage.height);
  
        const dataURL = await new Promise((innerResolve) => {
          const reader = new FileReader();
          reader.onloadend = () => innerResolve(reader.result);
          reader.readAsDataURL(resizedImageBlob);
        });
  
        resolve(dataURL);
      };
    });
  };
  const onImageChangeUpdate = (imageList) => {
    
   
    updateState({ images: imageList });
  };

  function addNewImage(img, images, newImage) {
    const imgName = img.file.name;
    const imgType = img.file.type;
    const img64 = img.data_url.split(";")[1].split(",")[1];
    images.push({
      imageb64: img64,
      imageName: imgName,
      imageType: imgType,
      image: img,
      src: newImage.src,
    });
  }

  const isValidData = () => {
    const category = selectedCategory?.label
      ? selectedCategory
      : prodCategories[0];

    let weightUnit = null;
    if (batCategories.includes(category.label)) {
      weightUnit = "lb";
    } else {
      weightUnit = "kg";
    }

    let images = state.images;

    

    const descErr = validator({ description });
    const priceErr = hasVariants ? false : validator({ productPrice });
    const quantityErr = hasVariants ? false : validator({ quantity });
    let ounceErr;
    let weightErr;

    if (weightUnit === "lb") {
      /*
      ounceErr = hasVariants
        ? false
        : validator({
            weight: selectedWeight?.value ?? null,
            weightUnit: "lb",
          });
      */
    } else {
      weightErr = hasVariants
        ? false
        : validator({
            weight: selectedWeight?.value ?? null,
            weightUnit: weightUnit,
          });
    }

    if (images.length === 0) {
      setImageError({ message: Messages.validation.isEmpty });
      //Product_Image_error_log
      AnalyticsService.logEvent("PRODUCT_Image_ERROR", {
        Error: Messages.validation.isEmpty,
      });
      setInvalidData(true);
      return false;
    } else {
      setImageError({});
    }

    if (descErr) {
      setDescError(descErr);
      //Product_description_error_log
      AnalyticsService.logEvent("PRODUCT_DESCRIPTION_ERROR", {
        Error: descErr,
      });
    } else {
      setDescError("");
    }
    if (priceErr) {
      setPriceError(priceErr);
      //Product_price_error_log
      AnalyticsService.logEvent("PRODUCT_PRICE_ERROR", {
        Error: priceErr,
      });
    } else {
      setPriceError("");
    }
    if (quantityErr) {
      setQuantityError(quantityErr);
      //Product_quantity_error_log
      AnalyticsService.logEvent("PRODUCT_QUANTITY_ERROR", {
        Error: quantityErr,
      });
    } else {
      setQuantityError("");
    }
    if (weightErr) {
      setWeightError(weightErr);
      AnalyticsService.logEvent("PRODUCT_WEIGHT_ERROR", {
        Error: weightErr,
      });
    } else if (ounceErr) {
      setWeightError(ounceErr);
      AnalyticsService.logEvent("PRODUCT_WEIGHT_ERROR", {
        Error: ounceErr,
      });
    } else {
      setWeightError("");
    }

    if (
      descErr ||
      priceErr ||
      quantityErr ||
      weightErr ||
      ounceErr ||
      videoErr ||
      imageError.message ||
      hasFormErrors(formErrors)
    ) {
      setInvalidData(true);
      return false;
    } else {
      setInvalidData(false);
      return true;
    }
  };

  const updateVariant = (variant) => {
    const updatedVariants = variants.map((v) => {
      if (v.id === variant.id) {
        return { ...v, ...variant };
      }
      return v;
    });
    setVariants(updatedVariants);
  };

  const saveForm = async () => {
    const category = selectedCategory?.label
      ? selectedCategory
      : prodCategories[0];

    let options = bespokeCategoryName === category.label
      ? []
      : optionsByCategory[category.label];
    let weightUnit = null;
    if (batCategories.includes(category.label)) {
        weightUnit = "lb";
      } else {
        weightUnit = "kg";
      }
    const tagValue = category.label;
    // let options = optionsByCategory[category.label];
    const checkValid = isValidData();
    let op1, op2, op3;
    if (checkValid && !imageError.index) {
      if (bespokeCategoryName === category.label) {
        selectedOptions &&
          selectedOptions.map((m, i) => {
            options.push({
              productId: 0,
              name: m.heading,
              position: i + 1,
              values: [m.selectedValue],
            });
            if (i === 0) {
              op1 = m.selectedValue;
            }
            if (i === 1) {
              op2 = m.selectedValue;
            }
            if (i === 2) {
              op3 = m.selectedValue;
            }
          });
      }
        updateState({ isLoading: true });
      const productImages = images.map((img) => {
        return {
          productId: 0,
          src: "",
          fileName: img.imageName,
          fileType: img.imageType,
          attachment: img.imageb64,
        };
      });
      const productVideos = videos.map((video) => {
        return {
          productId: 0,
          src: "",
          fileName: video.videoName,
          fileType: video.videoType,
          attachment: "",
          base64Chunk: video.videob64,
        };
      });
      const newProduct = {
        productId: 0,
        tbyb: tbyb.value,
        isExclusive: exclusiveTag.value,
        title: productName,
        modelId: selectedModel?.value,
        gradeId: selectedGrade?.value,
        customModel:customModel,
        customGrade:customGrade,
        description: description,
        vendor: "The Cricket Store",
        product_Type: "string",
        status: "active",
        tag:
          isTryBeforeYouBuy === true
            ? `${tagValue},Try before you buy`
            : tagValue,
        categoryId: category?.value,
        images: productImages,
        videos: productVideos,
        traits:traits
      };

      newProduct.options = options;

      if (variants.length !== 0) {
        newProduct.variants = variants.filter(x=>x.price>0)?.map((variant) => {
          return {
            productId: 0,
            fulfillmentService: "manual",
            inventoryManagement: "shopify",
            weight: variant.weight,
            weightUnit: weightUnit,
            inventoryQuantity: variant.inventoryQuantity
              ? Number(variant.inventoryQuantity)
              : Number(quantity),
            price: variant.price ? Number(variant.price) : Number(productPrice),
            ...(variant.option1 && { option1: variant.option1 }),
            ...(variant.option2 && { option2: variant.option2 }),
            ...(variant.option3 && { option3: variant.option3 }),
          };
        });
      } else {
        newProduct.variants = [
          {
            productId: 0,
            fulfillmentService: "manual",
            inventoryManagement: "shopify",
            weight: selectedWeight?.value,
            weightUnit: weightUnit,
            inventoryQuantity: Number(quantity),
            price: Number(productPrice),
            ...(op1 && { option1: op1 }),
            ...(op2 && { option2: op2 }),
            ...(op3 && { option3: op3 }),
          },
        ];
      }
      if(newProduct.variants.reduce((a,v) =>  a = a + v.price , 0 )==0){
        toast.error("Price not set");
        updateState({ isLoading: false });
      }else{
      const res = await apiPost(ADDNEWPRODUCT, newProduct);
      updateState({ isLoading: false });
      if (res){
         await getProducts();
         setShowProduct(false);
         setShowList(true);
         //Product_added_event_log
         AnalyticsService.logEvent("PRODUCT_ADDED_SUCCESSFULLY", {
           ProductName: productName,
           title: productName,
           description: description,
           vendor: "The Cricket Store",
           status: "active",
           tag: isTryBeforeYouBuy === true ? `${tagValue},tbyb` : tagValue,
         });
      }
      else{
        
        toast.error("Failed to add product");
      }
    
    }
  }
};

  const ImageLayout = (props) => {
    const { className, overlayClass, src, onClick } = props;
    return (
      <div className={className}>
        <div className={overlayClass} />
        <img src={src} className="formImg" />
        <IconButton onClick={onClick} className="imageRemoveCls" />
      </div>
    );
  };

  const onImageRemove = (deleteIndex) => {
    const allImages = images;
    allImages.splice(deleteIndex, 1);
    updateState({ images: allImages });
    if (imageError) imageError.index == deleteIndex && setImageError({});
    if (allImages.length === 0)
      setImageError({ message: Messages.validation.isEmpty });
    //Image_remove_event_log
    AnalyticsService.logEvent("PRODUCT_IMAGE_REMOVED_SUCCESSFULLY", {
      imageIndex: deleteIndex,
    });
  };
  const getVideoPlaytime = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        resolve(video.duration);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = URL.createObjectURL(file);
    });
  };
  const onVideoRemove = useCallback(
    (deleteIndex) => {
      const allVideos = videos;
      allVideos.splice(deleteIndex, 1);
      updateState({ videos: [...allVideos] });
      if (imageError) imageError.index == deleteIndex && setImageError({});
      if (allVideos.length === 0) setImageError({});

      if (allVideos.length === 0) {
        setVideoErr("");
      }
    },
    [videos, imageError]
  );

  const category = selectedCategory?.label
    ? selectedCategory
    : prodCategories[0];

  const weightTitle = `Weight (${
    batCategories.includes(category.label) ? "lb" : category ? "kg" : ""
  })`;

  const handleTraitSave = (traits)=>{
    setTraits(traits);
    setTraitsEdit(false);
  }

  return (
    <FormProvider {...methods}>
      {traitsEdit ? (
        <TraitsInput
          onCancel={()=>{setTraitsEdit(false)}}
          onSave={(traits)=>{handleTraitSave(traits)}}
          Traits={traits}
        />) : (<div>{selectedVariant ? (
        <VariantEdit
          isBat={batCategories.includes(category?.label)}
          weightTitle={weightTitle}
          variant={selectedVariant}
          productWeights={productWeights}
          onCancelClick={() => setSelectVariant(null)}
          isService={selectedCategory?.label === "Services"}
          onSave={() => {
            const { variants } = getValues();
            const variant = variants[selectedVariant.index];

            // if (!variant.gram) {
            //   variant.gram = 0;
            // }
            // if (!variant.kilogram) {
            //   variant.kilogram = 0;
            // }
            // const gToKg = variant.gram / 1000;

            // variant.weight = variant.kilogram + gToKg;

            if (batCategories.includes(category?.label)) {
              setValue(`variants[${selectedVariant.index}].weight`, 0, {
                shouldValidate: true,
              });
            } else {
              setValue(
                `variants[${selectedVariant.index}].weight`,
                variant.weight,
                { shouldValidate: true }
              );
            }
            updateVariant({
              ...selectedVariant,
              ...variant,
            });
            setSelectVariant(null);
          }}
        />
      ) : (
        <div className="formLayer">
          {invalidData && (
            <div className="desktopOnly">
              <ErrorWrapper
                text={"Please complete missing fields to save this item."}
              />
            </div>
          )}
          <div className="formLayer0">
            <Title text={"Add Item"} className="addItemCls" />
           {!isTabletOrMobile? <ActionButton2
              text="SAVE"
              onClick={handleSubmit(saveForm)}
              className="productSaveCls"
              isLoading={isLoading}
              marginTop={3}
              disabled={false}
            />
           : <ActionButton2
              text="CANCEL"
              color="#fff"
              onClick={onCancelClick}
              className="productCancelCls"
            />}
          </div>
          <div className="innerScroll">
          <div className="formLayer1" id="categorySelection">
            <Title text={"Category"} className="formLabelCls" />
            <Select
              placeholder={"Please select"}
              onChange={(option) => setSelectedCategory(option)}
              options={prodCategories}
              value={selectedCategory}
              defaultValue={prodCategories ? prodCategories[0] : undefined}
              isSearchable={false}
            />
          </div>
          
          <div className="formLayer1" id="categorySelection">
            <Title text={"Model"} className="formLabelCls" />
            <Select
              placeholder={"Please select"}
              onChange={(option) => setSelectedProductModel(option)}
              options={productModels.map((m) => ({
                value: m.id,
                label: m.name,
              }))}
              value={selectedModel}
              isSearchable={true}
              onInputChange={handleSelectedProductModelInputChange}
            />
          </div>
          
            <div className="formLayer1" id="categorySelection">
              <Title text={"Grade"} className="formLabelCls" />
              <Select
                placeholder={"Please select"}
                onChange={(option) => setSelectedProductGrade(option)}
                options={productGrades.map((m) => ({
                  value: m.id,
                  label: m.name,
                }))}
                value={selectedGrade}
                isSearchable={true}
                onInputChange={handleSelectedProductGradeInputChange}
                
              />
            </div>
        

          <div className="formLayer1">
            <Title text={"Product name"} className="formLabelCls" />
            <TextField
              
              name="productName"
              className="productField"
              value={productName}
              onChange={changeTextValues}
              isError={nameError}
              errorText={nameError}
            />
          </div>
          <div className="formLayer1" id="categorySelection">
            <Title text={"Exclusive"} className="formLabelCls" />
            <Select
              placeholder={"Please select"}
              onChange={setExclusiveTag}
              options={[
                { value: true, label: "YES" },
                { value: false, label: "NO" },
              ]}
              value={exclusiveTag}
            
            />
          </div>
          {category?.label === "Workshop Cricket Bats" && (
            <div className="formLayer1" id="categorySelection">
              <Title text={"TBYB"} className="formLabelCls" />
              <Select
                value={tbyb}
                onChange={settbyb}
                options={[
                  { value: true, label: "YES" },
                  { value: false, label: "NO" },
                ]}
              />
            </div>
          )}
          <div className="formLayer2Add">
            <div className="inforLayerCls">
              <div className="imgUploadInfo">
                <Title text={"Images"} className="formLabelCls" />
                <Title text={"(10 images max)"} className="subInfoLabel" />
              </div>
              <Title
                text={Messages.label.imageSizeInfo}
                className="infoLabel"
              />
            </div>
            <div
              className={`imgLayerCls ${
                imageError.message ? "border-error" : ""
              }`}
            >
              <ImageUploading
                data-testid="file-uploader"
                value={images}
                onChange={onImageChange}
                dataURLKey="data_url"
                maxFileSize={157286400}
                acceptType={["png", "jpg", "jpeg"]}
                multiple
                maxNumber={10}
                
              >
                {({
                  imageList,
                  onImageUpload,
                  dragProps,
                  isDragging,
                  errors,
                }) => (
                  <>
                    <div className="imageGrid" {...dragProps}>
                      {isDragging && ""}
                      <SecondaryButton
                        text={"ADD"}
                        className="addFormCls"
                        onClick={onImageUpload}
                        disabled={images.length === 10 ? true : false}
                      />
                      <Title
                        text={"Insert up to 10 images"}
                        className={"insertLabel"}
                      />
                      {/*  {imageList.length > 0 && (
                        <div className="top-spacing">
                          {imageList.map((image, index) => (
                            <React.Fragment key={index}>
                              {index === 0 && (
                                <ImageLayout
                                  className={"firstIndexImage"}
                                  overlayClass={"overlayFirstIndex"}
                                  src={image.image.data_url}
                                  onClick={() => onImageRemove(index)}
                                />
                              )}
                              {index === 1 && (
                                <ImageLayout
                                  className={"secondIndexImage"}
                                  overlayClass={"overlay"}
                                  src={image.image.data_url}
                                  onClick={() => onImageRemove(index)}
                                />
                              )}
                              {index === 2 && (
                                <ImageLayout
                                  className={"thirdIndexImage"}
                                  overlayClass={"overlay"}
                                  src={image.image.data_url}
                                  onClick={() => onImageRemove(index)}
                                />
                              )}
                              {index === 3 && (
                                <ImageLayout
                                  className={"fourthIndexImage"}
                                  overlayClass={"overlay"}
                                  src={image.image.data_url}
                                  onClick={() => onImageRemove(index)}
                                />
                              )}
                              {index === 4 && (
                                <ImageLayout
                                  className={"fifthIndexImage"}
                                  overlayClass={"overlay"}
                                  src={image.image.data_url}
                                  onClick={() => onImageRemove(index)}
                                />
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      )} */}
                    </div>
                    {errors && (
                      <div>
                        {errors.maxFileSize && (
                          <span className="errorTexCls">
                            Selected image size exceed 10MB
                          </span>
                        )}
                        {errors.resolution && (
                          <span className="errorTexCls">
                            Selected image resolution exceed 20MP
                          </span>
                        )}
                        {errors.maxNumber && (
                          <span className="errorTexCls">
                            Number of selected images exceed max (10) allowed
                            images.
                          </span>
                        )}
                        {errors.acceptType && (
                          <span className="errorTexCls">
                            Selected file type is not allowed.
                          </span>
                        )}
                      </div>
                    )}
                  </>
                )}
              </ImageUploading>
            </div>
          </div>

          <div style={{ paddingTop: 10 }}>
          {isImageLoading ? (
        
        <CircularProgress style={{ margin: 'auto', display: 'block' }}/>
      ) : (
        
        <DndProvider backend={HTML5Backend}>
          <Container
            dragData={state.images}
            onImageRemove={onImageRemove}
            onImageChangeUpdate={onImageChangeUpdate}
          />
        </DndProvider>
      )}
          </div>
          <div className="image-error">
            <ErrorText text={imageError.message} />
          </div>
          <div className="formLayer2Add">
            <div className="inforLayerCls">
              <div className="imgUploadInfo">
                <Title text={"Video"} className="formLabelCls" />
                <Title text={"(1 video max)"} className="subInfoLabel" />
              </div>
              {/* <Title text={Messages.label.imageSizeInfo} className="infoLabel" /> */}
            </div>
            <div className="imgLayerCls">
              <input
                ref={videoInputRef}
                type="file"
                accept="video/*"
                onChange={async (e) => {
                  if (!e.target.files) return;
                  setVideoErr("");

                   for (const file of e.target.files) {
                    const playtime = await getVideoPlaytime(file);

                    if(playtime > 600)
                    {
                      setVideoErr("Selected video playtime is above 10 minutes please select another video");
                      return;
                    }
                  }
                  const fileList = await getListFiles(
                    e.target.files,
                    "data_url"
                  );
                  const videoFiles = fileList.map((f) => toVideoData(f));
                  const updatedFileList = [...videos, ...videoFiles];
                  updateState({ videos: updatedFileList });

                  const fileSize = e.target.files[0].size;

                  if (fileSize > 150000000) {
                    setVideoErr("Video should be smaller than 150MB");
                    return;
                  } else {
                    setVideoErr("");
                  }
                }}
                style={{ display: "none" }}
              />
              <div className="imageGrid">
                <SecondaryButton
                  text={"ADD"}
                  className="addFormCls"
                  onClick={() => {
                    videoInputRef.current.click();
                  }}
                  disabled={videos.length === 1 ? true : false}
                />
                <Title
                  text={"Insert 1 video"}
                  className={"insertLabel"}
                />
                <div className="top-spacing">
                  {state.videos.map((videoFile, idx) => {
                    return (
                      <VideoLayout
                        key={idx}
                        idx={idx}
                        className={"firstIndexImage"}
                        overlayClass={"overlayFirstIndex"}
                        src={videoFile.video.data_url}
                        onClick={onVideoRemove}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            {videoErr && <ErrorText text={videoErr} />}
          </div>
          <div className="formLayer1T marginTop">
            <Title text={"Description"} className="formLabelCls" />
            <TextAreaInput
              name="description"
              value={description}
              onChange={changeTextValues}
              isError={descError}
              errorText={descError}
            />
          </div>
            {selectedCategory?.label === "Memorabilias" && <div className="formLayer1T marginTop">
              
              <ActionButton2
              text="Add Traits"
              onClick={()=>{setTraitsEdit(true)}}
              className="productSaveMobile"
              
              //isLoading={isLoading}
              marginTop={1}
              //disabled={isLoading}
            />
            </div>}
            
          
            <>
              <div className="formLayer3">
                <Title text={!hasVariants ?"Price (£)":"General Price (£)"} className="formLabelCls" />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    name="productPrice"
                    className="productField1"
                    value={productPrice}
                    onChange={(e)=>changeTextValues(e,hasVariants?1:null)}
                    isError={priceError}
                    errorText={priceError}
                  />
                </div>
              </div>
              {selectedCategory?.label != "Services" && 
              <div className="formLayer3">
              <Title text={!hasVariants ? "Quantity":"General Quantity"} className="formLabelCls" />
              <TextField
                name="quantity"
                className="productField1"
                value={quantity}
                onChange={(e)=>changeTextValues(e,hasVariants?2:null)}
                isError={quantityError}
                errorText={quantityError}
              />
            </div>
              }
              
            </>
          

          {variants.length > 0 ? (
            <div className="mt-1">
              <Title text={"Variants"} className="formLabelCls" />
              {variants.map((variant, index) => {
                return (
                  <VariantItem
                    key={variant.id + index}
                    variant={variant}
                    onClick={() => {
                      setSelectVariant({ ...variant, index });
                    }}
                    error={formErrors?.variants?.[index]}
                    isService={selectedCategory?.label === "Services"}
                  />
                );
              })}
            </div>
          ) : null}


          {bespokeCategoryName === (category?.label) &&
            bespokeBatOptions.length > 0 &&
            bespokeBatOptions.map((f) => {
              return (
                <div className="formLayer3" key={f.id}>
                  <div className="subInfoParent">
                    <Title text={f.heading} className="formLabelCls" />
                  </div>
                  <Select
                    placeholder={"Please select"}
                    isSearchable={false}
                    onChange={(option) => setOption(f.heading, option)}
                    options={f.fieldValues}
                    styles={{
                      menuList: (styles) => ({
                        ...styles,
                        maxHeight: 160,
                      }),
                    }}
                  />
                </div>
              );
            })}


          {/* <div className="formLayer3">
        <Title text={"Try before you buy"} className="formLabelCls" />
        <Select
        placeholder={"Try before you buy"}
        isSearchable={false}
        onChange={onIsTryBeforeYouBuyChange}
        options={isTryBeforeYouBuyOptions}
        defaultValue={
          isTryBeforeYouBuyOptions ? isTryBeforeYouBuyOptions[0] : undefined
        }
        />
        </div> */}

          </div>
          <div className="mobileOnly">
            {invalidData && (
              <ErrorWrapper text="Please complete missing fields to save this item." />
            )}
            <ActionButton2
              text="SAVE"
              onClick={saveForm}
              className="productSaveMobile"
              isLoading={isLoading}
              marginTop={3}
              disabled={isLoading}
            />
          </div>
        </div>
        )}</div>)}
      
    </FormProvider>
  );
};
